import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { isUserLogin } from '@eureka/utils/account';

export const useFormulationGuestMode = createSharedComposable(() => {
  const isLogin = ref(false);
  const isGuestMode = ref(false);

  const setGuestMode = async (value: boolean) => {
    isLogin.value = await isUserLogin();
    isGuestMode.value = value || !isLogin.value;
  };

  return {
    isLogin,
    isGuestMode,
    setGuestMode,
  };
});
